import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function ThumbsDown({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>ThumbsDown</title>
      <path
        d="M21 14C21 14.5523 20.5523 15 20 15H17V3H20C20.5523 3 21 3.44772 21 4V14Z"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.25 13C16.25 13.4142 16.5858 13.75 17 13.75C17.4142 13.75 17.75 13.4142 17.75 13H16.25ZM17 5H17.75C17.75 4.74924 17.6247 4.51506 17.416 4.37596L17 5ZM10 15.75C10.4142 15.75 10.75 15.4142 10.75 15C10.75 14.5858 10.4142 14.25 10 14.25V15.75ZM15.0077 3.6718L15.4237 3.04776L15.0077 3.6718ZM3.38813 12.6712L4.12793 12.7945L3.38813 12.6712ZM4.12793 12.7945L5.32199 5.6301L3.8424 5.3835L2.64834 12.5479L4.12793 12.7945ZM16.25 5V13H17.75V5H16.25ZM10 14.25H5.36092V15.75H10V14.25ZM7.54138 3.75H12.7889V2.25H7.54138V3.75ZM14.5917 4.29584L16.584 5.62404L17.416 4.37596L15.4237 3.04776L14.5917 4.29584ZM12.7889 3.75C13.4305 3.75 14.0578 3.93992 14.5917 4.29584L15.4237 3.04776C14.6435 2.52758 13.7267 2.25 12.7889 2.25V3.75ZM5.32199 5.6301C5.50282 4.54518 6.44149 3.75 7.54138 3.75V2.25C5.70823 2.25 4.14377 3.5753 3.8424 5.3835L5.32199 5.6301ZM2.64834 12.5479C2.36897 14.2241 3.66159 15.75 5.36092 15.75V14.25C4.5885 14.25 4.00094 13.5564 4.12793 12.7945L2.64834 12.5479Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M10.7354 15.1471C10.8167 14.7409 10.5533 14.3458 10.1471 14.2646C9.74092 14.1833 9.3458 14.4467 9.26456 14.8529L10.7354 15.1471ZM16 13V12.25C15.7159 12.25 15.4562 12.4105 15.3292 12.6646L16 13ZM17 13.75C17.4142 13.75 17.75 13.4142 17.75 13C17.75 12.5858 17.4142 12.25 17 12.25V13.75ZM10.0483 18.5829L10.7354 15.1471L9.26456 14.8529L8.5774 18.2888L10.0483 18.5829ZM15.3292 12.6646L12.03 19.2629L13.3717 19.9337L16.6708 13.3354L15.3292 12.6646ZM16 13.75H17V12.25H16V13.75ZM10.7504 19.7929C10.2448 19.6244 9.94373 19.1056 10.0483 18.5829L8.5774 18.2888C8.3245 19.5532 9.05275 20.8082 10.2761 21.2159L10.7504 19.7929ZM10.2761 21.2159C11.4833 21.6183 12.8026 21.0718 13.3717 19.9337L12.03 19.2629C11.7948 19.7333 11.2494 19.9592 10.7504 19.7929L10.2761 21.2159Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
